import React, { useState } from "react";
import { useEffect } from "react";
import "./SpotifyStyles.scss";
import { FaSpotify } from "react-icons/fa";
import { getNowPlaying } from "../../lib/spotify";

const SpotifyPlaying = () => {
    const [ playing, setPlaying ] = useState({} as any);
    const getPlaying = async () => {
        const nowPlayingRes = await getNowPlaying() as any;

        if (!nowPlayingRes) {
            setPlaying({ is_playing: false });
            return;
        }

        const { is_playing, item, progress_ms } = nowPlayingRes;
        if (!is_playing || !item) {
            setPlaying({ is_playing: false });
            return;
        }

        const { duration_ms, album, artists, name, external_urls, uri } = item;

        const song_name = name;
        const song_url = external_urls.spotify;
        
        const album_url = album.external_urls.spotify;
        const { images } = album;
        const album_name = album.name;
        const album_uri = album.uri;

        let song_image;
        let min_height = 1000;
        images.forEach(image => {
            if (image.height < min_height) {
                min_height = image.height;
                song_image = image.url;
            } 
        })

        const artist_meta = artists.reduce((meta, artist, _) => {
            const { name, uri } = artist; 
            const url = artist.external_urls.spotify;
            meta[name] = { uri, url };
            return meta;
        }, {});

        const song_meta = {
            is_playing,
            progress_ms,
            duration_ms,
            song_url,
            song_name,
            album_name, 
            song_uri: uri,
            album_uri,
            song_image_url: song_image,
            album_url,
            artists: artist_meta
        }

        setPlaying(song_meta)
    }
    useEffect(() => {
        getPlaying();
    }, []);

    const { artists, song_image_url, song_name, song_url, is_playing, album_name, album_uri } = playing;

    return (
        <div className="spotify-playing">
            <div className="listening">
                <p>{(is_playing ? '' : 'Not ') + 'Listening to Spotify'}</p>
                <p className="spotify-logo"><FaSpotify /></p>
            </div>
            {is_playing &&
            <div className="song-display">
                <div className="song-image">
                    <img src={song_image_url} alt="" />
                </div>
                <div className="song-meta">
                    <a className="title" href={song_url}>{song_name}</a>
                    <div className="artists"> {"by "}
                        {artists && Object.keys(artists).map((artist, idx) => (
                            <span><a href={artists[artist].url}>{artist + (idx === Object.keys(artists).length - 1 ? " " : ", ")}</a></span>
                        ))}
                    </div>
                    <div className="artists"> {"on "}
                        <span><a href={album_uri}>{album_name}</a></span>
                    </div>
                </div>
            </div>
            }
        </div>
    );
}

export default SpotifyPlaying;